<template>
  <li class="header-comparison" @mouseleave="hideModal">
    <button v-on="isTouch ? {click: toggleModal} : {click: handleClick, mouseenter: showModal}" class="user-actions__link">
      <ComparisonSvg/>
      <span v-if="productsToComparison.length" class="user-actions__cart-counter">{{ productsToComparison.length }}</span>
    </button>
    <HeaderPopup :is-popup-visible="isModalVisible" :is-empty-popup="!(comparisonInfoHeader && comparisonInfoHeader.data && Object.keys(comparisonInfoHeader.data).length)" type="comparison" >
      <div
        class="comparison-modal-categories__items"
        v-if="comparisonInfoHeader && comparisonInfoHeader.data && Object.keys(comparisonInfoHeader.data).length">
        <span class="comparison-modal__title">{{ $t('product_comparison') }}</span>
        <div class="comparison-modal-categories custom-scrollbar">
          <span
            class="comparison-modal-categories__item"
            v-for="(category, i) in comparisonInfoHeader.data"
            :key="i"
            @click="redirectToConcreteCategory($event, category)">
            {{ category.name }} ({{ Object.keys(category.product_list).length }})
            <button class="comparison-modal-categories__close-btn" @click="REMOVE_CATEGORY_FROM_COMPARISON(category.remove_cat_url)">
              <svg class="remove-category-btn"
                   fill="#909090"
                   width="10"
                   height="10"
                   viewBox="0 0 10 10"
                   xmlns="http://www.w3.org/2000/svg">
                <path class="remove-category-btn" d="M8.88873 9.99982L0 1.11109L1.11109 1.35666e-06L9.99982 8.88873L8.88873 9.99982Z"/>
                <path class="remove-category-btn" d="M0.000181322 8.88873L8.88891 0L10 1.11109L1.11127 9.99982L0.000181322 8.88873Z"/>
              </svg>
            </button>
          </span>
        </div>
        <Button class="comparison-modal-btn" @click.native="handleClick">{{ $t('to_compare') }}</Button>
      </div>
    </HeaderPopup>
    <div @click="hideModal"
         @mouseenter="hideModal"
         v-if="isOverlayOpen && isModalVisible && isMobile"
         class="comparison-overlay"></div>
  </li>
</template>

<script>
import Button from '../../inputs/Button'
import { mapActions, mapGetters, mapState } from 'vuex'
import ComparisonSvg from './ComparisonSvg'
import { isTouch } from '@/mixins/isTouchDevice'
import HeaderPopup from '@/components/helpers/HeaderPopup'
import { GoogleTagManagerService } from '@/services/AnalyticService'

export default {
  name: 'HeaderComparison',
  mixins: [isTouch],
  components: {
    HeaderPopup,
    ComparisonSvg,
    Button
  },
  props: {
    isMobile: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isModalVisible: false,
      windowWidth: null,
      isOverlayOpen: false
    }
  },
  computed: {
    ...mapState({
      comparisonInfoHeader: state => state.productComparison.comparisonInfoHeader,
      errorFromServer: state => state.checkout.errorFromServer
    }),
    ...mapGetters(['productsToComparison'])
  },
  methods: {
    ...mapActions(['FETCH_COMPARISON_INFO_HEADER', 'REMOVE_CATEGORY_FROM_COMPARISON']),
    handleClick () {
      GoogleTagManagerService.btnClickAnalytics({
        event: 'click_comparison'
      })
      const categories = this.comparisonInfoHeader.data
      const firstCategoryId = Object.keys(categories)[0]
      if (firstCategoryId) {
        window.location.href = categories[firstCategoryId].compare_url
      }
    },
    redirectToConcreteCategory ({ target }, category) {
      if (target.classList.value !== 'remove-category-btn') {
        window.location.href = category.compare_url
      }
    },
    showModal () {
      this.isModalVisible = true
      this.isOverlayOpen = true
    },
    hideModal () {
      this.isModalVisible = false
      this.isOverlayOpen = false
    },
    toggleModal () {
      this.isModalVisible = !this.isModalVisible
      this.isOverlayOpen = !this.isOverlayOpen
    }
  },
  watch: {
    errorFromServer (value) {
      if (value && !this.isHidden) {
        this.$notify({
          group: 'error',
          title: this.$t('error'),
          text: value,
          type: 'error'
        })
      }
    }
  }
}
</script>

<style scoped lang="sass">

</style>
